import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

const initialState = {
    status: null,
    message: null,
    data: null,
    configId: null
}


export const saveCredentials = createAsyncThunk("saveCredentials", async (credentials) => {
    try {
        const response = await fetch(`/api/saveInfo`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(credentials)
        })
        if (!response.ok) {
            throw new Error('Failed to save the credentials');
        }
        return await response.json();
    } catch (error) {
        throw new Error('Failed to save the credentials', error);
    }
});

const credentialsSlice = createSlice({
    name: "saveCredentials",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(saveCredentials.pending, (state) => {
            state.status = "Loading"
        });
        builder.addCase(saveCredentials.fulfilled, (state, action) => {
            state.status = "success"
            state.message = "Credentials saved successfully"
            state.data = action.payload.data
            state.configId = action.payload.data.data.struConfigId
        });
        builder.addCase(saveCredentials.rejected, (state) => {
            state.status = "error"
            state.message = "Credentials failed to save"
        });
    }
})

export default credentialsSlice.reducer